import Sprite from "app/components/sprite";
import { useAnimation } from "app/hooks/useAnimation";
import heroPhoneImg from "app/images/collections/hero-phone.png";
import { Trans } from "react-i18next";
import { useRef } from "react";

export const SayHelloToCollectionsSection = () => {
  const title = useRef(null);
  const description = useRef(null);
  const numbers = useRef(null);
  const phone = useRef(null);
  const vector = useRef(null);

  useAnimation([title, description, numbers, phone, vector]);

  return (
    <section className="relative z-10 h-full overflow-hidden bg-primary font-montserrat">
      <div className="zbooni-layout pt-20">
        <div className="mx-auto flex max-w-md  flex-col md:max-w-none ltr:md:flex-row rtl:md:flex-row-reverse">
          <div className="flex flex-1 flex-col gap-6 py-10 ltr:md:py-24 rtl:md:py-32 lg:gap-10 ltr:lg:py-32 rtl:lg:py-40">
            <p
              ref={title}
              className="font-medium leading-6 text-white md:max-w-xs md:text-base lg:max-w-md lg:text-lg"
              data-animation="animate__animated animate__fadeInDown"
            >
              <Trans>
                Although every business knows that emails end up unread and
                trashed, email marketing is one of the few tools available that
                is easy and affordable.{" "}
                <span className="font-bold">But not anymore.</span>
              </Trans>
            </p>
            <p
              ref={description}
              className="bg-gradient-to-r from-yellowgreen to-cyan-dark bg-clip-text text-[50px] font-black leading-[56px] text-transparent ltr:max-w-sm rtl:max-w-xs rtl:pb-2 rtl:text-[42px] rtl:md:max-w-[356px] lg:text-[65px] lg:leading-[72px] ltr:lg:max-w-[480px] rtl:lg:max-w-[480px] rtl:lg:pb-3 rtl:lg:text-[58px] xl:text-[75px] xl:leading-[84px] ltr:xl:max-w-[572px] rtl:xl:max-w-[572px] rtl:xl:pb-4 rtl:xl:text-[75px]"
              data-animation="animate__animated animate__fadeInDown animate__delay-1s"
            >
              <Trans>Say hello to Collections by Zbooni.</Trans>
            </p>
          </div>
          <div className="relative flex flex-1 ltr:justify-start rtl:justify-end md:justify-center">
            <Sprite
              svgRef={vector}
              dataAnimation="animate__animated animate__fadeInDown"
              name="gray-diamond"
              className="absolute -left-28 -top-4 h-[455px] w-[440px] md:-left-24 md:top-16 md:h-[517px] md:w-[500px] lg:-left-32 lg:top-40 lg:h-[680px] lg:w-[660px] xl:-left-16"
            />
            <div
              ref={numbers}
              className="absolute left-40 top-0 flex w-32 flex-col gap-1 md:left-56 md:top-16 lg:left-80 lg:w-36 lg:gap-2 xl:left-96"
              data-animation="animate__animated animate__fadeInRight"
            >
              <p
                lang="en"
                className="bg-gradient-to-r from-yellowgreen to-cyan-dark bg-clip-text font-extrabold text-transparent rtl:text-right"
              >
                <span className="text-[35px] leading-[42px] lg:text-[60px] lg:leading-[52px]">
                  90
                </span>
                <span className="align-top text-xl leading-9 lg:text-[30px]">
                  %
                </span>
              </p>
              <div className="h-2 w-full bg-gray-darker">
                <div className="h-full w-[90%] bg-gradient-to-r from-yellowgreen to-cyan-dark" />
              </div>
              <p className="text-xs font-bold text-white lg:text-sm">
                <Trans>More effective than email marketing</Trans>
              </p>
            </div>
            <img
              alt=""
              ref={phone}
              data-animation="animate__animated animate__fadeInUp"
              src={heroPhoneImg}
              className="bottom-0 left-12 w-[230px] md:absolute md:w-[280px] lg:left-20 lg:w-[360px] xl:left-36"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
